var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/*tslint:disable:no-null-keyword */
export var mapParticipants = function (x) {
    var emptyParticipant = {
        id: "",
        name: "",
        venueRole: null,
        country: "",
        metadata: {},
    };
    for (var i = 0; i < 2; i++) {
        if (x.participants.length <= i) {
            x.participants.push(emptyParticipant);
        }
        else {
            x.participants[i] = __assign({}, emptyParticipant, x.participants[i]);
        }
    }
    return x;
};
//# sourceMappingURL=mapParticipants.js.map